import { useMemo } from "react";

import { SeriesClickEventObject } from "highcharts";
import { IntlShape } from "react-intl";

import { getSourceTypeDisplayName, SupportedSources } from "@app/enum/SourceType";
import { DisplayType } from "@app/scene/home/enum/DisplayType";
import SourceSummary from "@app/types/source/SourceSummary";

const useSourceTypeChartConfig = (
  defaultConfig: object,
  displayType: DisplayType,
  onSourceTypeClick: (type: SupportedSources) => void,
  selectedSourceTypes: SupportedSources[],
  summaryData: SourceSummary[],
  intl: IntlShape
) =>
  useMemo(() => {
    const data = summaryData.filter((value) =>
      selectedSourceTypes.some((sourceType) => sourceType === value.key)
    );

    return {
      ...defaultConfig,
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: {
            enabled: true,
            format:
              displayType === DisplayType.PERCENT
                ? "<b>{point.name}</b> {point.percentage:.0f} %"
                : "<b>{point.name}</b> {y}",
          },
        },
      },
      series: [
        {
          cursor: "pointer",
          data: data.map((recordSourceSummary) => ({
            custom: { sourceType: recordSourceSummary.key },
            name: getSourceTypeDisplayName(intl, recordSourceSummary.key as SupportedSources),
            y: recordSourceSummary.doc_count,
          })),
          events: {
            click: (event: SeriesClickEventObject) => {
              onSourceTypeClick(event.point.options.custom!.sourceType as SupportedSources);
            },
          },
        },
      ],
    };
  }, [defaultConfig, displayType, intl, summaryData, selectedSourceTypes, onSourceTypeClick]);

export default useSourceTypeChartConfig;
